import { Button } from "antd";
import {
  useNavigate,
  useRouteError,
  isRouteErrorResponse,
} from "react-router-dom";

export const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  let errorMessage = "حدث خطأ غير متوقع";

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data || "خطأ غير معروف";
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "0.5rem",
      }}
      id="error-page"
    >
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{errorMessage}</i>
      </p>
      <Button className="mt-4" onClick={() => navigate("/", { replace: true })}>
        العودة للرئيسية
      </Button>
    </div>
  );
};
